import React, { Fragment } from "react";

const RemoveFriend = ({
  match,
  user,
  removeCasualFriend,
  setShowRemovedUser,
  removeCasualFriendNotifications,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() =>
              setShowRemovedUser({ request: false, confirm: false })
            }
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div
                className={`avi-color-border ${
                  user.role === "innovator"
                    ? "green"
                    : user.role === "mentor"
                    ? "red"
                    : user.role === "employer"
                    ? "blue"
                    : null
                }`}
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span
                    className={`name-font ${
                      user.role === "innovator"
                        ? "green"
                        : user.role === "mentor"
                        ? "red"
                        : user.role === "employer"
                        ? "blue"
                        : null
                    }`}
                  >
                    {user.firstname} {user.lastname}
                  </span>
                </li>
                <li className="user-online-item">{user.jobtitle}</li>
                <li className="user-online-item">
                  {user.location.city}, {user.location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Would you like to remove{" "}
            <span
              className={`bold ${
                user.role === "innovator"
                  ? "green"
                  : user.role === "mentor"
                  ? "red"
                  : user.role === "employer"
                  ? "blue"
                  : null
              }`}
            >
              {user.firstname} {user.lastname}
            </span>{" "}
            as a friend?
          </div>
          <div className="flex-center">
            <button
              className={`user-request-button ${
                user.role === "innovator"
                  ? "background-green"
                  : user.role === "mentor"
                  ? "background-red"
                  : user.role === "employer"
                  ? "background-blue"
                  : null
              }`}
              onClick={() =>
                removeCasualFriend({ user }, match.params.channelid) &&
                removeCasualFriendNotifications(user.channelid) &&
                setShowRemovedUser({ request: false, confirm: true })
              }
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className={`user-request-button ${
                user.role === "innovator"
                  ? "background-green"
                  : user.role === "mentor"
                  ? "background-red"
                  : user.role === "employer"
                  ? "background-blue"
                  : null
              }`}
              onClick={() =>
                setShowRemovedUser({ request: false, confirm: false })
              }
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RemoveFriend;
